import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual'
import User from "../../../../assets/icon/user1.png"

class NavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            navClose: { right: '0px' }
        }
    }

    componentWillMount() {
        if (window.innerWidth < 750) {
            this.setState({ navClose: { right: '-410px' } })
        }
        if (window.innerWidth < 1199) {
            this.setState({ navClose: { right: '-300px' } })
        }
    }

    openNav() {
        this.setState({ navClose: { right: '0px' } })
    }
    closeNav() {
        this.setState({ navClose: { right: '-410px' } })
    }

    onMouseEnterHandler() {
        if (window.innerWidth > 1199) {
            document.querySelector("#main-menu").classList.add("hover-unset");
        }
    }

    handleSubmenu = (event) => {
        if (event.target.classList.contains('sub-arrow'))
            return;

        if (event.target.nextElementSibling.classList.contains('opensubmenu'))
            event.target.nextElementSibling.classList.remove('opensubmenu')
        else {
            document.querySelectorAll('.nav-submenu').forEach(function (value) {
                value.classList.remove('opensubmenu');
            });
            document.querySelector('.mega-menu-container').classList.remove('opensubmenu')
            event.target.nextElementSibling.classList.add('opensubmenu')
        }
    }

    handleMegaSubmenu = (event) => {
        if (event.target.classList.contains('sub-arrow'))
            return;

        if (event.target.parentNode.nextElementSibling.classList.contains('opensubmegamenu'))
            event.target.parentNode.nextElementSibling.classList.remove('opensubmegamenu')
        else {
            document.querySelectorAll('.menu-content').forEach(function (value) {
                value.classList.remove('opensubmegamenu');
            });
            event.target.parentNode.nextElementSibling.classList.add('opensubmegamenu')
        }
    }
    logout = (e) => {
        e.preventDefault();
        window.localStorage.removeItem("user_info");
        window.location.reload(window.location.href);
    };
    render() {
        const { translate } = this.props;
        return (
            <div>
                <div className="main-navbar">
                    <div id="mainnav" >
                        <div className="toggle-nav" onClick={this.openNav.bind(this)} >
                            <i className="fa fa-bars sidebar-bar"></i>
                        </div>
                        <ul className="nav-menu" style={this.state.navClose}>
                            <li className="back-btn"  >
                                <div className="mobile-back text-right" onClick={this.closeNav.bind(this)}>
                                    <span >بازگشت</span>
                                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                                </div>

                            </li>
                            <li className='mobile-menu'>
                                <Link to={`${process.env.PUBLIC_URL}/pages/profile`} >


                                    <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end' }}>
                                        <div className='mt-2 mr-2'>
                                            {JSON.parse(localStorage.getItem('user_info')) ?

                                                <h6> {JSON.parse(localStorage.getItem('user_info')).fullName}</h6>
                                                :
                                                <h6>ورود/ثبت نام</h6>
                                            }

                                        </div>
                                        <div style={{ width: '40px', height: '40px' }}>
                                            <img src={User} />
                                        </div>

                                    </div>

                                </Link>
                            </li>
                            <li >
                                <Link to={`${process.env.PUBLIC_URL}/pages/contact`} className="nav-link">
                                    {translate('contact_us')}
                                </Link>

                            </li>
                            {/* <li >
                                <Link to="#" className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
                                    {translate('Immigration_services')}
                                    <span className="sub-arrow"></span>
                                </Link> */}
                            {/* <ul className="nav-submenu">
                                    <li><Link to={`${process.env.PUBLIC_URL}/left-sidebar/collection`} >{translate('category_left_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/right-sidebar/collection`} >{translate('category_right_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/no-sidebar/collection`} >{translate('category_no_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/metro/collection`} >{translate('category_metro')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/full-width/collection`} >{translate('category_full_width')}</Link></li>
                                </ul> */}
                            {/* </li> */}
                            {/* <li >
                                <Link to="#" className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
                                    {translate('Foreign_currency_payment')}
                                    <span className="sub-arrow"></span>
                                </Link> */}
                            {/* <ul className="nav-submenu">
                                    <li><Link to={`${process.env.PUBLIC_URL}/left-sidebar/product/1`} >{translate('left_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/right-sidebar/product/1`} >{translate('right_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/no-sidebar/product/1`} >{translate('no_sidebar')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/col-left/product/1`} >{translate('three_col_thumbnail_left')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/col-right/product/1`} >{translate('three_col_thumbnail_right')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/column/product/1`} >{translate('thumbnail_below')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/left-image/product/1`} >{translate('thumbnail_left')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/right-image/product/1`} >{translate('thumbnail_right')}</Link></li>
                                </ul> */}
                            {/* </li> */}

                            <li>
                                <Link to={`${process.env.PUBLIC_URL}/pages/coming-soon`} className="nav-link" onClick={(e) => this.handleSubmenu(e)}>
                                    {translate('credit_card')}
                                    <span className="sub-arrow"></span>
                                </Link>
                                {/* <ul className="nav-submenu">
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/about-us`} >{translate('about_us')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/rules`} >قوانین و مقررات</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/404`} >404</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/lookbook`} >{translate('lookbook')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/login`} >{translate('login')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/profile`} >{translate('profile')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/register`} >{translate('register')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/search`} >{translate('search')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/collection`} >{translate('collection')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/forget-password`} >{translate('forget_password')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/contact`} >{translate('contact')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/dashboard`} >{translate('dashboard')}</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/pages/faq`} >{translate('FAQ')}</Link></li>
                                </ul> */}
                            </li>
                            <li >
                                <Link to={`${process.env.PUBLIC_URL}/pages/coming-soon`} className="nav-link">
                                    {translate('number')}
                                </Link>

                            </li>
                            <li className="mega-menu">
                                <Link className="dropdown nav-link" to={`${process.env.PUBLIC_URL}/products`} onClick={(e) => this.handleSubmenu(e)}>
                                    {translate('card_gift')}
                                    <span className="sub-arrow"></span>
                                </Link>
                                <div className="mega-menu-container" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col mega-box">
                                                <div className="link-section">
                                                    <div className="menu-title" >
                                                        <h5 onClick={(e) => this.handleMegaSubmenu(e)}>
                                                            فروشگاه انلاین
                                                            <span className="sub-arrow"></span>
                                                        </h5>
                                                    </div>
                                                    <div className="menu-content">
                                                        <ul>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=33`} >گیفت کارت آمازون</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=34`} >گیفت کارت Ebay</Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mega-box">
                                                <div className="link-section">
                                                    <div className="menu-title" >
                                                        <h5 onClick={(e) => this.handleMegaSubmenu(e)}>
                                                            بازی
                                                            <span className="sub-arrow"></span>
                                                        </h5>
                                                    </div>
                                                    <div className="menu-content">
                                                        <ul>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=9`} >گیفت کارت ایکس باکس</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=24`} >گیفت کارت پلی استیشن</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=12`} >گیفت کارت استیم</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=13`} >گیفت کارنینتندو</Link></li>
                                                            {/*<li><Link to={`${process.env.PUBLIC_URL}/features/element-ratio`} >{translate('image_size_ratio')}</Link></li>*/}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mega-box">
                                                <div className="link-section">
                                                    <div className="menu-title" >
                                                        <h5 onClick={(e) => this.handleMegaSubmenu(e)}>
                                                            فیلم و سریال
                                                            <span className="sub-arrow"></span>
                                                        </h5>
                                                    </div>
                                                    <div className="menu-content" >
                                                        <ul>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=32`} >گیفت کارت نتفلیکس</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=49`} >گیفت کارت اپل تی وی پلاس</Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mega-box">
                                                <div className="link-section">
                                                    <div className="menu-title" >
                                                        <h5 onClick={(e) => this.handleMegaSubmenu(e)}>
                                                            {translate('application')}
                                                            <span className="sub-arrow"></span>
                                                        </h5>
                                                    </div>
                                                    <div className="menu-content" >
                                                        <ul>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=3`} >گیفت کارت اپل</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=4`} >گیفت کارت گوگل پلی</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=5`} >گیفت کارت اسپاتیفای</Link></li>
                                                            <li><Link to={`${process.env.PUBLIC_URL}/products?id=6`} >گیفت کارت ماکروسافت</Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="col mega-box">
                                                <div className="link-section">
                                                    <div className="menu-title" >
                                                        <h5 onClick={(e) => this.handleMegaSubmenu(e)}>
                                                            {translate('men_accessories')}
                                                            <span className="sub-arrow"></span>
                                                        </h5>
                                                    </div>
                                                    <div className="menu-content" >
                                                        <ul>
                                                            <li><a href="#">{translate('ties')}</a></li>
                                                            <li><a href="#">{translate('cufflinks')}</a></li>
                                                            <li><a href="#">{translate('pockets_squares')}</a></li>
                                                            <li><a href="#">{translate('helmets')}</a></li>
                                                            <li><a href="#">{translate('scarves')}</a></li>
                                                            <li><a href="#">{translate('phone_cases')}</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li >
                                <Link to='/' className="nav-link">
                                    خانه
                                </Link>

                            </li>
                            {JSON.parse(localStorage.getItem('user_info')) &&
                                <li className='mobile-menu'>
                                    <Link to={`${process.env.PUBLIC_URL}/pages/profile#edit-Profile`} className="nav-link">
                                        پیشخوان
                                    </Link>

                                </li>
                            }

                            {JSON.parse(localStorage.getItem('user_info')) &&

                                <li className='mobile-menu'>

                                    <Link to={`${process.env.PUBLIC_URL}/pages/profile#edit-Profile`} className=' nav-link'>

                                        ویرایش پروفایل
                                    </Link>
                                </li>
                            }
                            {JSON.parse(localStorage.getItem('user_info')) &&
                                <li className='mobile-menu '>

                                    <Link to={`${process.env.PUBLIC_URL}/pages/profile#orders`} className='nav-link'>

                                        سفارشات
                                    </Link>
                                </li>
                            }
                            {JSON.parse(localStorage.getItem('user_info')) &&
                                <li className='mobile-menu' onClick={this.logout}>
                                    <div className='nav-link logout-menu'>

                                        خروج
                                    </div>
                                </li>
                            }

                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}


export default withTranslate(NavBar);